import React, { memo } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { INavRoute } from 'types/routes'

const NAVBAR_HEIGHT_PX = 48

interface ISubRouteProps {
  route: INavRoute
}

const useSubRouteStyles = makeStyles({
  root: {
    padding: 0,
  },
  linkWrapper: {},
  link: {
    height: NAVBAR_HEIGHT_PX,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    color: brandColors.coolGray4,
    backgroundColor: brandColors.coolGray8,

    '&:hover': {
      textDecoration: 'none',
      color: brandColors.white,
      backgroundColor: brandColors.coolGray7,
    },
  },
  title: {},
})

const SubRoute = memo<ISubRouteProps>(({ route }) => {
  const { location, name } = route || {}
  const classes = useSubRouteStyles()
  const wrapperClass = classNames(classes.root)
  return (
    <li key={name} className={wrapperClass} data-test='SubRoute'>
      <a href={location} className={classes.link}>
        <span className={classes.title}>{name}</span>
      </a>
    </li>
  )
})

export default SubRoute
